export default "__VITE_ASSET__DadO_XO___"